import React from 'react'
import CustomAlert from '../../shared/CustomAlert'
import { observer } from 'mobx-react-lite'
import { MDBCollapse } from 'mdb-react-ui-kit'
import CarrierStore from './../Carrier.store'

import './SpecRequireContract.scss'

const SpecRequireContract = ({ spec }) => (
  <MDBCollapse open={CarrierStore.isSpecActive(spec)} className='SpecRequireContractComponent'>
    <CustomAlert
      color={!CarrierStore._required[spec] || `${CarrierStore._required[spec]}` === '0' ? 'success' : 'danger'}
      className='text-center'
    >
      {!CarrierStore._required[spec] || `${CarrierStore._required[spec]}` === '0' ? (
        <>
          Great! You&apos;ve contracted enough carriers to earn the <strong>{spec}</strong> specialization.
        </>
      ) : (
        <>
          Requires at least <strong>{CarrierStore._required[spec]}</strong> more <strong>{spec}</strong> carrier
          contracts to complete the specialization.
        </>
      )}
    </CustomAlert>
  </MDBCollapse>
)

export default observer(SpecRequireContract)
